<template>
  <b-row>
    <b-row class="row content" style="margin: 0;right: 0; min-height: calc(100vh - 80px)">
      <b-col md="6" xs="12">
        <b-img fluid src="../assets/images/anasayfa1.jpg"/>
      </b-col>
      <b-col md="5" xs="12" style="padding-bottom: 30px">
        <div class="header text-center">
          <h1 class="mor">sinavanaliz.ankaradil.com</h1>
          <h2>Giriş yapılıyor lütfen bekleyiniz.</h2>
        </div>
      </b-col>
    </b-row>
    <b-container class="footer text-center"><a href="https://www.ankaradil.com"> Ankara Dil Akademisi </a> için <a href="https://code4edu.com"> code4edu.com  </a> tarafından hazırlanmıştır.</b-container>
  </b-row>
</template>

<script>
import {mapActions} from 'vuex'
import axios from 'axios'

export default {
  name: 'Callback',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    ...mapActions([
      'Login_ACTION'
    ])
  },
  async mounted () {
    try {
      // alert('mounted')
      const code = this.$route.query.code
      var d = { code: code }
      axios
        .post(this.$serviceAddress + 'api/v5/checkLoginCasdoor', d)
        .then(async (response) => {
          this.isLoading = false
          let data = response.data
          if (data.result === 1) {
            data.router = this.$router
            this.Login_ACTION(data)
          } else {
            this.alertMessage = 'Kullanıcı Girişi Yapılırken bir hata oluştu :' + data.err
            this.showDismissibleAlert = true
          }
        }).catch((error) => {
          console.log(error)
          this.isLoading = false
          this.alertMessage = 'Kullanıcı Girişi Yapılırken bir hata oluştu :' + error
          this.showDismissibleAlert = true
        })
    } catch (e) {
      console.log(e)
      this.$router.push('/loginProblem')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.header{
  margin-top: 25%;
}
.mor{
  color:#7c7cb0
}
.footer {
  /*position: absolute;*/
  width: 100%;
  height: 80px
}
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/Callback.vue